import { GET } from '../request'

export const getLlamadas = fecha =>
  GET('/api/core/marketing/llamada/list/day', { fecha })
